
// LoginPage.js 

import React, { useState, useContext, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
//import axios from 'axios';
import api from '../../config/axiosConfig'; // ajuste o caminho

function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setAuth, setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  // Referência para o campo de senha
  const passwordInputRef = useRef(null);

  // Limpa o localStorage quando a página de login é inicializada
  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');  // Limpa o erro ao tentar logar novamente

    try {
      // Fazendo a requisição de login
      // const response = await axios.post('http://localhost:8080/login', {
      const response = await api.post('/login', {
        username,
        password,
      });

      // Verifique a estrutura da resposta
      console.log('Resposta da API:', response.data);

      const userData = response.data;

      // Armazena o token se presente na resposta
      const token = userData.token; // Verifique se o token está corretamente presente
      if (token) {
        localStorage.setItem('token', token);
      } else {
        console.error('Token não encontrado na resposta.'); // Log extra para depuração
      }

      // Após o login bem-sucedido, fazer a requisição para buscar os dados do usuário logado
      //const userResponse = await axios.get('http://localhost:8080/usuarios/logado', {
      const userResponse = await api.get('/usuarios/logado', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const userLogadoData = userResponse.data;

      // Armazenar no localStorage
      localStorage.setItem('username', userLogadoData.username);
      localStorage.setItem('name', userLogadoData.name);
      localStorage.setItem('role', userLogadoData.role);
      localStorage.setItem('acesso', userLogadoData.acesso);

      setUser(userLogadoData); // Atualiza o contexto de usuário
      setAuth(true); // Sinaliza que o usuário está autenticado
      navigate('/home'); // Navega para a página inicial
      window.alert('Logado com sucesso');

    } catch (error) {
      // Tratamento de erros
      if (!error.response) {
        setError('Erro ao acessar o servidor'); // Servidor fora do ar ou inacessível
      } else if (error.response.status === 401) {
        setError('Usuário ou senha inválidos');
      } else {
        setError('Erro inesperado ao fazer login');
        console.error('Erro no login:', error.response); // Log para depuração de outros erros
      }
    }
  };

 
  // Função para lidar com o pressionamento de tecla no campo de usuário
  const handleUsernameKeyPress = (e) => {
    if (e.key === 'Enter' && e.target.name === 'username') {
      // Impede o envio do formulário ao pressionar Enter
      e.preventDefault();
      // Foca no campo de senha automaticamente
      passwordInputRef.current.focus();
    }
  };

  return (
    <div className="login-alfatek">
      <div>
        <h2>Login Alfatek Sistemas</h2>
        <form className="login-form">
          <input
            type="text"
            name="username"
            placeholder="Usuário"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={handleUsernameKeyPress} // Lida com o Enter no campo de usuário
          />
          <input
            type="password"
            name="password"
            placeholder="Senha"
            autoComplete="new-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            ref={passwordInputRef} // Referência para o campo de senha
          />
          <button
            type="submit"
            className="btn-login"
            onClick={(e) => handleLogin(e)} // Chama a função de login ao clicar
          >
            Entrar
          </button>
        </form>
        {/* Exibe a mensagem de erro, caso exista */}
        {error && <p>{error}</p>}
      </div>
    </div>
  );
}

export default LoginPage;